/* ═══════════════════════════════════════════════════════════════
   SYSTEMA — HYPER-CLASS MOTION ENGINE
   World-class awwwards-level animation JS
   Powered by GSAP + ScrollTrigger
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── BAIL on reduced-motion ── */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(pointer: coarse)').matches;

  /* ── GSAP guard ── */
  function waitForGSAP(cb) {
    if (window.gsap && window.ScrollTrigger) { cb(); return; }
    var t = setInterval(function () {
      if (window.gsap && window.ScrollTrigger) { clearInterval(t); cb(); }
    }, 50);
  }

  /* ═══════════════════════════════════════
     1. SPLIT TEXT UTILITY
     ═══════════════════════════════════════ */
  function splitIntoChars(el, className) {
    var html = el.innerHTML.trim();
    var parts = html.split(/(<br\s*\/?>)/i);
    var idx = 0;
    el.innerHTML = parts.map(function (part) {
      if (/^<br/i.test(part)) return part;
      var text = part.trim();
      if (!text) return '';
      var words = text.split(/\s+/);
      return words.map(function (word) {
        var chars = word.split('').map(function (c) {
          var delay = idx * 0.03;
          idx++;
          return '<span class="sys-char-wrap" style="display:inline-block; overflow:hidden; vertical-align:top;"><span class="sys-char" style="transition-delay:' + delay.toFixed(3) + 's; display:inline-block;">' + c + '</span></span>';
        }).join('');
        return '<span class="sys-word" style="display:inline-block">' + chars + '</span>';
      }).join(' ');
    }).join('');
    el.setAttribute('data-sys-split', 'true');
    return el;
  }

  function splitIntoWords(el) {
    var html = el.innerHTML.trim();
    var parts = html.split(/(<br\s*\/?>)/i);
    var idx = 0;
    el.innerHTML = parts.map(function (part) {
      if (/^<br/i.test(part)) return part;
      var text = part.trim();
      if (!text) return '';
      var words = text.split(/\s+/);
      return words.map(function (word) {
        var delay = idx * 0.06;
        idx++;
        return '<span class="sys-word"><span class="sys-word-inner" style="transition-delay:' + delay.toFixed(3) + 's">' + word + '</span></span>';
      }).join(' ');
    }).join('');
    el.setAttribute('data-sys-split', 'true');
    return el;
  }

  function splitIntoLines(el) {
    var text = el.innerHTML.trim();
    var lines = text.split(/<br\s*\/?>/i);
    if (lines.length <= 1) {
      lines = text.split('\n').filter(function (l) { return l.trim(); });
    }
    if (lines.length <= 1) {
      el.classList.add('sys-line-reveal');
      el.innerHTML = '<span class="sys-line">' + text + '</span>';
    } else {
      el.classList.add('sys-line-reveal');
      el.innerHTML = lines.map(function (line, i) {
        var delay = i * 0.12;
        return '<span class="sys-line" style="transition-delay:' + delay.toFixed(2) + 's">' + line.trim() + '</span>';
      }).join('');
    }
    el.setAttribute('data-sys-split', 'true');
    return el;
  }

  /* ═══════════════════════════════════════
     2. CUSTOM CURSOR
     ═══════════════════════════════════════ */
  function initCursor() {
    if (isMobile || reduced) return;

    var cursor = document.querySelector('.sys-cursor');
    var dot = document.querySelector('.sys-cursor-dot');
    var text = document.querySelector('.sys-cursor-text');
    if (!cursor || !dot) return;

    var mx = 0, my = 0;
    var cx = 0, cy = 0;
    var dx = 0, dy = 0;
    var active = false;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;
      if (!active) {
        active = true;
        cursor.classList.add('is-active');
        dot.classList.add('is-active');
        document.body.classList.add('sys-cursor-active');
      }
    });

    document.addEventListener('mouseleave', function () {
      cursor.classList.remove('is-active');
      dot.classList.remove('is-active');
      active = false;
    });

    function tick() {
      cx += (mx - cx) * 0.12;
      cy += (my - cy) * 0.12;
      dx += (mx - dx) * 0.25;
      dy += (my - dy) * 0.25;
      cursor.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)';
      dot.style.transform = 'translate(' + dx + 'px,' + dy + 'px) translate(-50%,-50%)';
      if (text) {
        text.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)';
      }
      requestAnimationFrame(tick);
    }
    tick();

    /* Hover targets */
    function addCursorHover(selector, cls, label) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.addEventListener('mouseenter', function () {
          cursor.classList.add(cls);
          if (label && text) {
            text.textContent = label;
            text.classList.add('is-active');
          }
        });
        el.addEventListener('mouseleave', function () {
          cursor.classList.remove(cls);
          if (text) {
            text.classList.remove('is-active');
            text.textContent = '';
          }
        });
      });
    }

    addCursorHover('a, button, .sys-magnetic', 'is-hover', '');
    addCursorHover('.sys-carousel__card, .lookbook-item, .sys-cats__link', 'is-hover-text', 'VIEW');
    addCursorHover('.collection-square', 'is-hover-text', 'EXPLORE');
  }

  /* ═══════════════════════════════════════
     3. MAGNETIC ELEMENTS
     ═══════════════════════════════════════ */
  function initMagnetics() {
    if (isMobile || reduced) return;

    document.querySelectorAll('.sys-magnetic').forEach(function (el) {
      var strength = parseFloat(el.getAttribute('data-sys-mag-strength')) || 0.3;

      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        el.style.transform = 'translate(' + (x * strength) + 'px,' + (y * strength) + 'px)';
      });

      el.addEventListener('mouseleave', function () {
        el.style.transform = 'translate(0,0)';
      });
    });
  }

  /* ═══════════════════════════════════════
     4. SCROLL PROGRESS BAR
     ═══════════════════════════════════════ */
  function initScrollProgress() {
    var bar = document.querySelector('.sys-scroll-progress');
    if (!bar) return;

    function updateProgress() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      bar.style.width = progress + '%';
    }
    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }

  /* ═══════════════════════════════════════
     5. 3D TILT CARDS
     ═══════════════════════════════════════ */
  function initTilt() {
    if (isMobile || reduced) return;

    document.querySelectorAll('.sys-tilt').forEach(function (el) {
      var maxTilt = parseFloat(el.getAttribute('data-sys-tilt-max')) || 5;

      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;
        var y = (e.clientY - rect.top) / rect.height;
        var rotateX = (0.5 - y) * maxTilt;
        var rotateY = (x - 0.5) * maxTilt;
        el.style.transform = 'perspective(800px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
      });

      el.addEventListener('mouseleave', function () {
        el.style.transform = 'perspective(800px) rotateX(0deg) rotateY(0deg)';
      });
    });
  }

  /* ═══════════════════════════════════════
     6. DRAG SCROLL WITH MOMENTUM
     ═══════════════════════════════════════ */
  function initDragScroll() {
    document.querySelectorAll('.sys-drag-scroll').forEach(function (track) {
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      var velX = 0;
      var lastX = 0;
      var animFrame;

      track.addEventListener('mousedown', function (e) {
        isDown = true;
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        lastX = e.pageX;
        track.style.cursor = 'grabbing';
        track.style.scrollSnapType = 'none';
        cancelAnimationFrame(animFrame);
      });

      track.addEventListener('mouseleave', function () { isDown = false; track.style.cursor = 'grab'; });
      track.addEventListener('mouseup', function () {
        isDown = false;
        track.style.cursor = 'grab';
        /* Momentum */
        function momentumTick() {
          if (Math.abs(velX) > 0.5) {
            track.scrollLeft += velX;
            velX *= 0.92;
            animFrame = requestAnimationFrame(momentumTick);
          } else {
            track.style.scrollSnapType = 'x mandatory';
          }
        }
        momentumTick();
      });

      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        var walk = (x - startX) * 1.5;
        track.scrollLeft = scrollLeft - walk;
        velX = lastX - e.pageX;
        lastX = e.pageX;
      });

      track.style.cursor = 'grab';
    });
  }

  /* ═══════════════════════════════════════
     7. CAROUSEL PROGRESS BAR
     ═══════════════════════════════════════ */
  function initCarouselProgress() {
    document.querySelectorAll('.sys-carousel__track').forEach(function (track) {
      var section = track.closest('.sys-carousel');
      if (!section) return;
      var progressWrap = section.querySelector('.sys-carousel-progress');
      if (!progressWrap) return;
      var progressBar = progressWrap.querySelector('.sys-carousel-progress__bar');
      if (!progressBar) return;

      track.addEventListener('scroll', function () {
        var max = track.scrollWidth - track.clientWidth;
        var pct = max > 0 ? track.scrollLeft / max : 0;
        var barWidth = track.clientWidth / track.scrollWidth * 100;
        progressBar.style.width = barWidth + '%';
        progressBar.style.transform = 'translateX(' + (pct * (100 / (barWidth / 100) - 100)) + '%)';
      }, { passive: true });
    });
  }

  /* ═══════════════════════════════════════
     8. MARQUEE VELOCITY
     ═══════════════════════════════════════ */
  function initMarqueeVelocity() {
    if (reduced) return;
    var marquees = document.querySelectorAll('.sys-marquee');
    if (!marquees.length) return;

    var lastScroll = window.pageYOffset;
    var scrollVelocity = 0;

    window.addEventListener('scroll', function () {
      var current = window.pageYOffset;
      scrollVelocity = Math.abs(current - lastScroll);
      lastScroll = current;
    }, { passive: true });

    function updateMarquees() {
      marquees.forEach(function (m) {
        var inner = m.querySelector('.sys-marquee__inner');
        if (!inner) return;

        /* Speed boost based on scroll velocity */
        var baseSpeed = parseFloat(inner.getAttribute('data-sys-base-speed')) || 28;
        var boost = Math.max(0.6, 1 - scrollVelocity * 0.003);
        inner.style.animationDuration = (baseSpeed * boost) + 's';

        /* Skew based on scroll direction */
        var skew = Math.min(2, Math.max(-2, scrollVelocity * 0.1 * (window.pageYOffset > lastScroll ? 1 : -1)));
        inner.style.transform = 'skewX(' + skew + 'deg)';
      });

      scrollVelocity *= 0.9;
      requestAnimationFrame(updateMarquees);
    }
    updateMarquees();
  }

  /* ═══════════════════════════════════════
     9. GSAP SCROLL-TRIGGERED REVEALS
     ═══════════════════════════════════════ */
  function initGSAPEngine() {
    waitForGSAP(function () {
      gsap.registerPlugin(ScrollTrigger);

      /* ── Clip-path reveals ── */
      document.querySelectorAll('.sys-reveal-left, .sys-reveal-right, .sys-reveal-up, .sys-reveal-down').forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 85%',
          onEnter: function () { el.classList.add('is-revealed'); },
          once: true
        });
      });

      /* ── Fade-up reveals ── */
      ScrollTrigger.batch('.sys-fade-up', {
        start: 'top 88%',
        onEnter: function (batch) {
          batch.forEach(function (el, i) {
            setTimeout(function () { el.classList.add('is-revealed'); }, i * 100);
          });
        },
        once: true
      });

      /* ── Scale-in reveals ── */
      ScrollTrigger.batch('.sys-scale-in', {
        start: 'top 88%',
        onEnter: function (batch) {
          batch.forEach(function (el, i) {
            setTimeout(function () { el.classList.add('is-revealed'); }, i * 80);
          });
        },
        once: true
      });

      /* ── Blur-in reveals ── */
      ScrollTrigger.batch('.sys-blur-in', {
        start: 'top 85%',
        onEnter: function (batch) {
          batch.forEach(function (el, i) {
            setTimeout(function () { el.classList.add('is-revealed'); }, i * 100);
          });
        },
        once: true
      });

      /* ── Lift reveals ── */
      ScrollTrigger.batch('.sys-lift', {
        start: 'top 88%',
        onEnter: function (batch) {
          batch.forEach(function (el, i) {
            setTimeout(function () { el.classList.add('is-revealed'); }, i * 120);
          });
        },
        once: true
      });

      /* ── Text reveals (split text) ── */
      document.querySelectorAll('.sys-line-reveal').forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 85%',
          onEnter: function () { el.classList.add('is-revealed'); },
          once: true
        });
      });

      /* ── Ken Burns ── */
      document.querySelectorAll('.sys-ken-burns').forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 80%',
          onEnter: function () { el.classList.add('is-playing'); },
          once: true
        });
      });

      /* ── Border-draw buttons ── */
      document.querySelectorAll('.sys-btn-draw').forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 90%',
          onEnter: function () { el.classList.add('is-revealed'); },
          once: true
        });
      });

      /* ── Float after reveal ── */
      document.querySelectorAll('.sys-float').forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 85%',
          onEnter: function () { el.classList.add('is-revealed'); },
          once: true
        });
      });

      /* ── Parallax elements (Vertical) ── */
      document.querySelectorAll('[data-sys-speed]').forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-sys-speed')) || 0.5;
        gsap.to(el, {
          yPercent: speed * -20,
          ease: 'none',
          scrollTrigger: {
            trigger: el.closest('.shopify-section') || el.parentElement,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
          }
        });
      });

      /* ── Parallax elements (Horizontal) ── */
      document.querySelectorAll('[data-sys-speed-x]').forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-sys-speed-x')) || 0.5;
        gsap.to(el, {
          xPercent: speed * -20,
          ease: 'none',
          scrollTrigger: {
            trigger: el.closest('.shopify-section') || el.parentElement,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
          }
        });
      });

      /* ── Shopify Editor ── */
      document.addEventListener('shopify:section:load', function () {
        ScrollTrigger.refresh();
      });
    });
  }

  /* ═══════════════════════════════════════
     10. PRELOADER
     ═══════════════════════════════════════ */
  function initPreloader() {
    if (reduced) {
      document.body.classList.remove('sys-loading');
      document.body.classList.add('sys-loaded');
      return;
    }

    /* Animate preloader characters in */
    setTimeout(function () {
      document.body.classList.add('sys-preloader-ready');
    }, 100);

    /* Wait for fonts + minimum display time */
    var minTime = new Promise(function (resolve) { setTimeout(resolve, 1200); });
    var fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();

    Promise.all([minTime, fontsReady]).then(function () {
      document.body.classList.add('sys-loaded');
      document.body.classList.remove('sys-loading');

      /* Remove preloader from DOM after transition */
      setTimeout(function () {
        var preloader = document.querySelector('.sys-preloader');
        if (preloader) preloader.remove();
      }, 800);
    });
  }

  /* ═══════════════════════════════════════
     11. SECTION-SPECIFIC INIT
     ═══════════════════════════════════════ */

  /* Hero cinematic reveal */
  function initHero() {
    var hero = document.querySelector('.sys-hero');
    if (!hero) return;

    var media = hero.querySelector('.sys-hero__media');
    var img = hero.querySelector('.sys-hero__img');
    var eyebrow = hero.querySelector('.sys-hero__eyebrow');
    var title = hero.querySelector('.sys-hero__title');
    var sub = hero.querySelector('.sys-hero__sub');
    var btn = hero.querySelector('.sys-hero__btn');

    /* Add animation classes */
    if (media) media.classList.add('sys-reveal-left');
    if (img) img.classList.add('sys-ken-burns');
    if (eyebrow) { eyebrow.classList.add('sys-fade-up'); eyebrow.style.transitionDelay = '0.8s'; }
    if (title && !title.getAttribute('data-sys-split')) {
      splitIntoChars(title, 'sys-char');
    }
    if (sub) { sub.classList.add('sys-fade-up'); sub.style.transitionDelay = '1.2s'; }
    if (btn) {
      btn.classList.add('sys-scale-in', 'sys-magnetic');
      btn.style.transitionDelay = '1.4s';
    }

    /* Trigger hero reveals after preloader */
    function triggerHeroReveal() {
      if (media) media.classList.add('is-revealed');
      if (img) img.classList.add('is-playing');
      if (title) title.classList.add('is-revealed');
      if (eyebrow) eyebrow.classList.add('is-revealed');
      if (sub) sub.classList.add('is-revealed');
      if (btn) btn.classList.add('is-revealed');
    }

    if (reduced) {
      triggerHeroReveal();
    } else {
      /* Wait for preloader to finish */
      setTimeout(triggerHeroReveal, 1400);
    }
  }

  /* Categories staggered grid */
  function initCategories() {
    document.querySelectorAll('.sys-cats__item').forEach(function (item, i) {
      var imgWrap = item.querySelector('.sys-cats__img-wrap');
      var badge = item.querySelector('.sys-cats__badge');

      if (imgWrap) {
        imgWrap.classList.add('sys-reveal-up');
        imgWrap.style.transitionDelay = (i * 0.12) + 's';
      }
      if (badge) {
        badge.classList.add('sys-fade-up', 'sys-magnetic');
        badge.style.transitionDelay = (0.4 + i * 0.12) + 's';
        badge.setAttribute('data-sys-mag-strength', '0.2');
      }
    });

    var heading = document.querySelector('.sys-cats__heading');
    if (heading && !heading.getAttribute('data-sys-split')) {
      splitIntoChars(heading, 'sys-char');
    }
  }

  /* Bestsellers carousel enhancements */
  function initBestsellersCarousel() {
    document.querySelectorAll('.sys-carousel__track').forEach(function (track) {
      track.classList.add('sys-drag-scroll');
    });

    document.querySelectorAll('.sys-carousel__card').forEach(function (card) {
      card.classList.add('sys-tilt');
      card.setAttribute('data-sys-tilt-max', '4');
    });

    document.querySelectorAll('.sys-carousel__btn').forEach(function (btn) {
      btn.classList.add('sys-magnetic');
      btn.setAttribute('data-sys-mag-strength', '0.35');
    });

    document.querySelectorAll('.sys-carousel__item').forEach(function (item, i) {
      item.classList.add('sys-fade-up');
      item.style.transitionDelay = (i * 0.1) + 's';
    });
  }

  /* Video hero parallax */
  function initVideoHero() {
    var section = document.querySelector('.sys-video-hero');
    if (!section) return;

    var media = section.querySelector('.sys-video-hero__media');
    var title = section.querySelector('.sys-video-hero__title');
    var sub = section.querySelector('.sys-video-hero__sub');
    var btn = section.querySelector('.sys-video-hero__btn');

    if (media) media.setAttribute('data-sys-speed', '0.6');
    if (title && !title.getAttribute('data-sys-split')) {
      splitIntoLines(title);
    }
    if (sub) sub.classList.add('sys-fade-up');
    if (btn) {
      btn.classList.add('sys-scale-in', 'sys-magnetic');
    }
  }

  /* Lookbook staggered reveals */
  function initLookbook() {
    var directions = ['sys-reveal-left', 'sys-reveal-right', 'sys-reveal-up', 'sys-reveal-down'];
    document.querySelectorAll('.lookbook-item').forEach(function (item, i) {
      var dir = directions[i % directions.length];
      item.classList.add(dir);
      item.style.transitionDelay = (i * 0.15) + 's';
    });
  }

  /* Testimonials perspective cascade */
  function initTestimonials() {
    document.querySelectorAll('.wv-testimonial-card, .testimonial-card, [class*="testimonial"]').forEach(function (card, i) {
      if (card.tagName === 'SECTION') return;
      card.classList.add('sys-lift');
      card.style.transitionDelay = (i * 0.15) + 's';
    });
  }

  /* Logo blur reveal */
  function initLogos() {
    document.querySelectorAll('.sys-ll-item, .wv-ll-item, [class*="logo-list"] [class*="item"]').forEach(function (logo, i) {
      logo.classList.add('sys-blur-in', 'sys-float');
      logo.style.transitionDelay = (i * 0.1) + 's';
    });
  }

  /* Rich text dramatic reveal */
  function initRichText() {
    document.querySelectorAll('.sys-rt, [class*="rich-text"]').forEach(function (section) {
      if (section.tagName === 'STYLE' || section.tagName === 'SCRIPT') return;
      var heading = section.querySelector('h2');
      var text = section.querySelector('p');
      var btn = section.querySelector('a, button');

      if (heading && !heading.getAttribute('data-sys-split')) {
        splitIntoChars(heading, 'sys-char');
      }
      if (text) {
        text.classList.add('sys-fade-up');
        text.style.transitionDelay = '0.4s';
      }
      if (btn) {
        btn.classList.add('sys-btn-draw', 'sys-magnetic');
      }
    });
  }

  /* Image with text horizontal wipe */
  function initImageWithText() {
    document.querySelectorAll('[class*="image-with-text"], .sys-iwt').forEach(function (section) {
      if (section.tagName === 'STYLE' || section.tagName === 'SCRIPT') return;
      var img = section.querySelector('img');
      var heading = section.querySelector('h2');
      var text = section.querySelector('p');

      if (img) {
        var wrap = img.closest('[class*="img"]') || img.parentElement;
        if (wrap) wrap.classList.add('sys-reveal-left');
      }
      if (heading && !heading.getAttribute('data-sys-split')) {
        splitIntoWords(heading);
      }
      if (text) {
        text.classList.add('sys-fade-up');
        text.style.transitionDelay = '0.3s';
      }
    });
  }

  /* Blog card reveals */
  function initBlog() {
    document.querySelectorAll('.wv-fb-card, [class*="blog"] [class*="card"], .sys-fb-card').forEach(function (card, i) {
      card.classList.add('sys-lift');
      card.style.transitionDelay = (i * 0.12) + 's';
    });

    document.querySelectorAll('.wv-fb-heading, .sys-fb-heading').forEach(function (heading) {
      if (!heading.getAttribute('data-sys-split')) {
        splitIntoChars(heading, 'sys-char');
      }
    });
  }

  /* ═══════════════════════════════════════
     12. GLOBAL HEADER SCROLL
     ═══════════════════════════════════════ */
  function initHeaderScroll() {
    var header = document.querySelector('.wv-header');
    if (!header) return;
    
    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  /* ═══════════════════════════════════════
     MASTER INIT
     ═══════════════════════════════════════ */
  function init() {
    initPreloader();
    initScrollProgress();
    initCursor();
    initHeaderScroll();

    /* Section-specific setup */
    initHero();
    initCategories();
    initBestsellersCarousel();
    initVideoHero();
    initLookbook();
    initTestimonials();
    initLogos();
    initRichText();
    initImageWithText();
    initBlog();

    /* Interactive systems */
    initMagnetics();
    initTilt();
    initDragScroll();
    initCarouselProgress();
    initMarqueeVelocity();

    /* GSAP engine (after DOM setup) */
    if (!reduced) {
      initGSAPEngine();
    }
  }

  /* ── Run ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify Editor reload */
  document.addEventListener('shopify:section:load', function () {
    initMagnetics();
    initTilt();
    initDragScroll();
    initCursor();
    if (!reduced) initGSAPEngine();
  });

})();
